export enum FlowInstanceAiStatus {
  Initial = 'initial',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}
